module.exports = __webpack_public_path__ + "img/close.30847ae1.svg";